import { inject, Injectable } from '@angular/core';
import { SnackBarService } from './snack-bar.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private snackBarService = inject(SnackBarService);

  constructor() { }

  procesarError(error: HttpErrorResponse, mensajeDefault?: string): void {
    let message = 'Ha ocurrido un error';

    switch (error.status) {
      case 401:
        message = 'Sesión inválida';
        break;
      case 403:
        message = 'Acceso denegado';
        break;
      case 404:
        message = 'No encontrado';
        break;
      case 500:
        message = mensajeDefault ?? 'Ha ocurrido un error';
        break;
      default:
        if (error.error?.message) 
          message = error.error.message;
        else if (typeof error?.error === 'string') 
          message = error.error;
        else 
          message = mensajeDefault;
    }

    this.snackBarService.showError(message);
  }
}
